<template lang="pug">

    //- Step-Navigation
    .ui.three.steps
        .step(v-bind:class='{ active: step === 1, completed: step > 1  }')
            i.building.icon
            .content
                .title Unternehmen erstellen
        .step(v-bind:class='{ active: step === 2, completed: step > 2, disabled: step < 2  }')
            i.shipping.icon
            .content
                .title Adresse erstellen
        .step(v-bind:class='{ active: step === 3, disabled: step < 3  }')
            i.user.icon
            .content
                .title Benutzer erstellen

</template>

<script>

    //noinspection ReservedWordAsName
    export default {

        props: {
            step: {
                type: Number,
                default: 1
            }
        }

    }

</script>
